export const comments = [
  { id: "cm-01", user: "追剧的小鱼", time: "2小时前", likes: 128, content: "第18集真的太好哭了，看到外婆笑着红了眼眶那里，我直接泪崩。这部剧的烟火气太真实了。" },
  { id: "cm-02", user: "暖阳与海", time: "5小时前", likes: 96, content: "秀雅这个角色演得太有层次了，温柔但不软弱，坚韧又不咄咄逼人，韩志旼真的绝。" },
  { id: "cm-03", user: "夜行的猫", time: "昨天", likes: 74, content: "承宇从最开始的冷漠到后面撑伞那段，转变特别自然，兄妹俩的线写得很细腻。" },
  { id: "cm-04", user: "橘子汽水", time: "昨天", likes: 61, content: "就喜欢这种安安静讲生活的剧，没有狗血，每一集都像在喝一碗热汤。" },
  { id: "cm-05", user: "慢慢走呀", time: "2天前", likes: 45, content: "配乐加分很多，尤其是餐桌那几段，音乐一起来情绪就上来了。" },
  { id: "cm-06", user: "一只小满", time: "3天前", likes: 33, content: "期待大结局！希望秀雅能在这个家真正找到属于自己的位置。" },
];

export default comments;